__turbopack_context__.v({
  "colorScheme--muted": "qtyWsW_colorScheme--muted",
  "container": "qtyWsW_container",
  "icon": "qtyWsW_icon",
  "isEmpty": "qtyWsW_isEmpty",
  "isSelected": "qtyWsW_isSelected",
  "option": "qtyWsW_option",
  "placeholder": "qtyWsW_placeholder",
  "size--lg": "qtyWsW_size--lg",
  "size--sm": "qtyWsW_size--sm",
  "value": "qtyWsW_value",
});
